import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  btn: {
    borderRadius: `0 ${theme.borderRadius.md} ${theme.borderRadius.md} 0`,
    padding: 9,

    '&.MuiButton-secondary': {
      '&:hover': {
        background: theme.secondary.s1,

        '& svg path': {
          fill: theme.primary.p2,
        },
      },
    },

    '& svg': {
      width: 24,
      height: 24,
    },
  },
  btnDark: {
    '&.MuiButton-secondary': {
      background: theme.background.b2,

      '&:hover': {
        background: theme.background.b2,

        '& svg path': {
          fill: theme.primary.p2,
        },
      },

      '&:focus': {
        background: theme.background.b2,

        '& svg path': {
          fill: theme.primary.p2,
        },
      },
    },
  },
}));

export default useStyles;
